module.exports = __webpack_public_path__ + "static/media/tags-check.544c37c4.svg";